import React from "react";

function Icon({ children }) {
  return (
    <span className="hs-shot-ico" aria-hidden="true">
      {children}
    </span>
  );
}

function MapIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <path d="M4 6l5-2 6 2 5-2v14l-5 2-6-2-5 2V6z" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M9 4v14M15 6v14" fill="none" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    </Icon>
  );
}

function ChartIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <path d="M5 19V9M12 19V5M19 19v-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </Icon>
  );
}

function ColumnsIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <rect x="3" y="5" width="5" height="14" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <rect x="10" y="5" width="5" height="14" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <rect x="17" y="5" width="5" height="14" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    </Icon>
  );
}

function CalendarIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <rect x="4" y="5" width="16" height="15" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8 3v4M16 3v4M4 10h16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    </Icon>
  );
}

function CapIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <path d="M3 10l9-4 9 4-9 4-9-4z" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M7 12v4c2 2 8 2 10 0v-4" fill="none" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    </Icon>
  );
}

function ExamIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <rect x="5" y="3" width="14" height="18" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8 8h8M8 12h8M8 16h5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    </Icon>
  );
}

function PathIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <circle cx="6" cy="7" r="2.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="18" cy="17" r="2.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8 8c4 0 4 8 8 8" fill="none" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    </Icon>
  );
}

export function SnapshotPanel() {
  return (
    <div className="hs-shot hs-shot--panel hs-shot--clip">
      <video
        className="hs-shot-clip"
        src="/home-clips/catchment-bucks-reading.mp4?v=1"
        poster="/home-clips/catchment-bucks-reading.jpg?v=1"
        autoPlay
        muted
        loop
        playsInline
        aria-label="Buckinghamshire and Reading grammar catchments overlapping on the map"
        onError={(event) => {
          const node = event.currentTarget;
          const img = document.createElement("img");
          img.className = "hs-shot-clip";
          img.alt = "Buckinghamshire and Reading grammar catchments overlapping on the map";
          img.src = "/home-clips/catchment-bucks-reading.gif?v=1";
          img.onerror = () => {
            img.onerror = null;
            img.src = "/home-clips/catchment-overlap.gif?v=2";
          };
          node.replaceWith(img);
        }}
      />
      <div className="hs-shot-clip-caption">
        <MapIcon />
        <span>Bucks + Reading + Kendrick catchments on the live map</span>
      </div>
    </div>
  );
}

export function SnapshotAlloc() {
  return (
    <div className="hs-shot hs-shot--alloc">
      <div className="hs-shot-bar">
        <strong>
          <ChartIcon /> Allocation history
        </strong>
        <span>Offers</span>
      </div>
      <ul className="hs-shot-rows">
        <li>
          <b>2025</b>
          <div>
            <strong>All offers inside Designated Area</strong>
            <em>Last score filled from the priority band</em>
          </div>
        </li>
        <li className="is-on">
          <b>2024</b>
          <div>
            <strong>Designated Area only</strong>
            <em>Outside area · no places reached</em>
          </div>
        </li>
        <li>
          <b>2023</b>
          <div>
            <strong>Same pattern held</strong>
            <em>Useful context before you apply</em>
          </div>
        </li>
      </ul>
      <p className="hs-shot-note">Published offer patterns — not a promise for any one child.</p>
    </div>
  );
}

export function SnapshotRank() {
  return (
    <div className="hs-shot hs-shot--rank">
      <div className="hs-shot-bar">
        <strong>
          <ChartIcon /> Ranking
        </strong>
        <span>163 schools</span>
      </div>
      <div className="hs-shot-table-wrap">
        <table className="hs-shot-table hs-shot-rk">
          <thead>
            <tr className="hs-shot-rk-groups">
              <th className="hs-shot-rk-school" rowSpan={2}>
                School
              </th>
              <th className="hs-shot-rk-g hs-shot-rk-g--gcse" colSpan={3}>
                GCSE
              </th>
              <th className="hs-shot-rk-g hs-shot-rk-g--alevel" colSpan={3}>
                A level
              </th>
              <th className="hs-shot-rk-g hs-shot-rk-g--after" colSpan={2}>
                Leavers
              </th>
              <th className="hs-shot-rk-g hs-shot-rk-g--ofsted" rowSpan={2}>
                Ofsted
              </th>
              <th className="hs-shot-rk-g hs-shot-rk-g--miles" rowSpan={2}>
                Miles
              </th>
            </tr>
            <tr className="hs-shot-rk-cols">
              <th className="hs-shot-rk-b hs-shot-rk-b--gcse">Rank</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--gcse">Att. 8</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--gcse">Grade 9</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--alevel">Rank</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--alevel">Points</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--alevel">A*</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--after">University</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--after">Oxbridge</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>Queen Elizabeth&apos;s</strong>
                <em>Barnet · Boys</em>
              </td>
              <td className="hs-shot-rk-b--gcse">1</td>
              <td className="hs-shot-rk-b--gcse">85.2</td>
              <td className="hs-shot-rk-b--gcse">48%</td>
              <td className="hs-shot-rk-b--alevel">2</td>
              <td className="hs-shot-rk-b--alevel">52.1</td>
              <td className="hs-shot-rk-b--alevel">41%</td>
              <td className="hs-shot-rk-b--after">94%</td>
              <td className="hs-shot-rk-b--after">62</td>
              <td className="hs-shot-rk-b--ofsted">Outstanding</td>
              <td className="hs-shot-rk-b--miles">4.2</td>
            </tr>
            <tr className="is-on">
              <td>
                <strong>The Tiffin Girls&apos;</strong>
                <em>Kingston · Girls</em>
              </td>
              <td className="hs-shot-rk-b--gcse">2</td>
              <td className="hs-shot-rk-b--gcse">84.1</td>
              <td className="hs-shot-rk-b--gcse">46%</td>
              <td className="hs-shot-rk-b--alevel">3</td>
              <td className="hs-shot-rk-b--alevel">51.4</td>
              <td className="hs-shot-rk-b--alevel">39%</td>
              <td className="hs-shot-rk-b--after">92%</td>
              <td className="hs-shot-rk-b--after">15</td>
              <td className="hs-shot-rk-b--ofsted">Outstanding</td>
              <td className="hs-shot-rk-b--miles">3.1</td>
            </tr>
            <tr>
              <td>
                <strong>Wilson&apos;s School</strong>
                <em>Sutton · Boys</em>
              </td>
              <td className="hs-shot-rk-b--gcse">3</td>
              <td className="hs-shot-rk-b--gcse">83.6</td>
              <td className="hs-shot-rk-b--gcse">45%</td>
              <td className="hs-shot-rk-b--alevel">1</td>
              <td className="hs-shot-rk-b--alevel">52.8</td>
              <td className="hs-shot-rk-b--alevel">42%</td>
              <td className="hs-shot-rk-b--after">93%</td>
              <td className="hs-shot-rk-b--after">37</td>
              <td className="hs-shot-rk-b--ofsted">Outstanding</td>
              <td className="hs-shot-rk-b--miles">5.8</td>
            </tr>
            <tr>
              <td>
                <strong>The Latymer School</strong>
                <em>Enfield · Mixed</em>
              </td>
              <td className="hs-shot-rk-b--gcse">4</td>
              <td className="hs-shot-rk-b--gcse">82.9</td>
              <td className="hs-shot-rk-b--gcse">43%</td>
              <td className="hs-shot-rk-b--alevel">5</td>
              <td className="hs-shot-rk-b--alevel">49.6</td>
              <td className="hs-shot-rk-b--alevel">36%</td>
              <td className="hs-shot-rk-b--after">91%</td>
              <td className="hs-shot-rk-b--after">—</td>
              <td className="hs-shot-rk-b--ofsted">Outstanding</td>
              <td className="hs-shot-rk-b--miles">6.4</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="hs-shot-note">Live ranking bands — without #, Grade 8–9, or A*–A in this preview.</p>
    </div>
  );
}

export function SnapshotCompare() {
  return (
    <div className="hs-shot hs-shot--compare">
      <div className="hs-shot-bar">
        <strong>
          <ColumnsIcon /> Compare
        </strong>
        <span>3 of 4 selected</span>
      </div>
      <div className="hs-shot-cp">
        <div className="hs-shot-cp-corner">Metric</div>
        <div className="hs-shot-cp-head is-on">The Tiffin Girls&apos;</div>
        <div className="hs-shot-cp-head">Nonsuch High</div>
        <div className="hs-shot-cp-head">Wallington Girls</div>

        <div className="hs-shot-cp-metric">Gender</div>
        <div className="hs-shot-cp-cell">Girls</div>
        <div className="hs-shot-cp-cell">Girls</div>
        <div className="hs-shot-cp-cell">Girls</div>

        <div className="hs-shot-cp-metric">Ofsted</div>
        <div className="hs-shot-cp-cell">Outstanding</div>
        <div className="hs-shot-cp-cell">Outstanding</div>
        <div className="hs-shot-cp-cell">Outstanding</div>

        <div className="hs-shot-cp-metric">Miles from home</div>
        <div className="hs-shot-cp-cell is-best">3.1</div>
        <div className="hs-shot-cp-cell">4.8</div>
        <div className="hs-shot-cp-cell">5.2</div>

        <div className="hs-shot-cp-group">GCSE</div>
        <div className="hs-shot-cp-group-fill" />
        <div className="hs-shot-cp-group-fill" />
        <div className="hs-shot-cp-group-fill" />

        <div className="hs-shot-cp-metric">GCSE rank</div>
        <div className="hs-shot-cp-cell is-best">2</div>
        <div className="hs-shot-cp-cell">6</div>
        <div className="hs-shot-cp-cell">11</div>

        <div className="hs-shot-cp-metric">Attainment 8</div>
        <div className="hs-shot-cp-cell is-best">84.1</div>
        <div className="hs-shot-cp-cell">82.4</div>
        <div className="hs-shot-cp-cell">80.1</div>

        <div className="hs-shot-cp-metric">Grade 9</div>
        <div className="hs-shot-cp-cell is-best">46%</div>
        <div className="hs-shot-cp-cell">42%</div>
        <div className="hs-shot-cp-cell">38%</div>

        <div className="hs-shot-cp-group hs-shot-cp-group--alevel">A level</div>
        <div className="hs-shot-cp-group-fill hs-shot-cp-group--alevel" />
        <div className="hs-shot-cp-group-fill hs-shot-cp-group--alevel" />
        <div className="hs-shot-cp-group-fill hs-shot-cp-group--alevel" />

        <div className="hs-shot-cp-metric">Points per entry</div>
        <div className="hs-shot-cp-cell is-best">51.4</div>
        <div className="hs-shot-cp-cell">49.8</div>
        <div className="hs-shot-cp-cell">48.2</div>

        <div className="hs-shot-cp-metric">A*</div>
        <div className="hs-shot-cp-cell is-best">39%</div>
        <div className="hs-shot-cp-cell">36%</div>
        <div className="hs-shot-cp-cell">33%</div>

        <div className="hs-shot-cp-group hs-shot-cp-group--after">Destinations</div>
        <div className="hs-shot-cp-group-fill hs-shot-cp-group--after" />
        <div className="hs-shot-cp-group-fill hs-shot-cp-group--after" />
        <div className="hs-shot-cp-group-fill hs-shot-cp-group--after" />

        <div className="hs-shot-cp-metric">Higher education</div>
        <div className="hs-shot-cp-cell is-best">92%</div>
        <div className="hs-shot-cp-cell">90%</div>
        <div className="hs-shot-cp-cell">88%</div>
      </div>
      <p className="hs-shot-note">Same compare board — overview, GCSE, A level, destinations.</p>
    </div>
  );
}

export function SnapshotOxbridge() {
  return (
    <div className="hs-shot hs-shot--oxbridge">
      <div className="hs-shot-bar">
        <strong>
          <CapIcon /> Destinations
        </strong>
        <span>School file</span>
      </div>
      <div className="hs-shot-grid2">
        <div className="hs-shot-metric">
          <span>Oxbridge offers</span>
          <strong>Published</strong>
          <em>Where the school releases a count</em>
        </div>
        <div className="hs-shot-metric">
          <span>Higher education</span>
          <strong>Leavers %</strong>
          <em>DfE destinations extract</em>
        </div>
      </div>
      <ul className="hs-shot-bullets">
        <li>Shown in the school file next to GCSE and A level</li>
        <li>Useful sixth-form context — not a guarantee for your child</li>
        <li>Missing figure means we do not invent one</li>
      </ul>
    </div>
  );
}

export function SnapshotExams() {
  return (
    <div className="hs-shot hs-shot--exams">
      <div className="hs-shot-bar">
        <strong>
          <ExamIcon /> Exam details
        </strong>
        <span>Year 7</span>
      </div>
      <ul className="hs-shot-rows hs-shot-rows--rich">
        <li className="is-on">
          <b>Stage one</b>
          <div>
            <strong>English &amp; maths</strong>
            <em>Often a shared paper with neighbouring grammars</em>
          </div>
        </li>
        <li>
          <b>Stage two</b>
          <div>
            <strong>By invitation</strong>
            <em>After stage one — check this school&apos;s dates</em>
          </div>
        </li>
        <li>
          <b>Register</b>
          <div>
            <strong>School deadline</strong>
            <em>Usually summer before Year 6 — confirm on the card</em>
          </div>
        </li>
        <li>
          <b>Subjects</b>
          <div>
            <strong>What the papers cover</strong>
            <em>Named in the admissions policy extract</em>
          </div>
        </li>
      </ul>
    </div>
  );
}

export function SnapshotDeadlines() {
  return (
    <div className="hs-shot hs-shot--deadlines">
      <div className="hs-shot-bar">
        <strong>
          <CalendarIcon /> Key dates · Year 7
        </strong>
        <span>Don&apos;t miss</span>
      </div>
      <div className="hs-shot-deadline-grid">
        <article>
          <em>Summer</em>
          <strong>Open evening</strong>
          <span>See the school · ask catchment questions</span>
        </article>
        <article className="is-on">
          <em>1 Jul – 1 Sep</em>
          <strong>Register for tests</strong>
          <span>School registration · preferred early</span>
        </article>
        <article>
          <em>Sep</em>
          <strong>Stage one exam</strong>
          <span>English, maths, reasoning as named</span>
        </article>
        <article>
          <em>Oct</em>
          <strong>Stage two / results</strong>
          <span>Invitation or selective status</span>
        </article>
        <article>
          <em>31 Oct</em>
          <strong>CAF / SCAF deadline</strong>
          <span>Name the school on your LA form</span>
        </article>
        <article>
          <em>1 Mar</em>
          <strong>National Offer Day</strong>
          <span>Secondary offers land</span>
        </article>
      </div>
    </div>
  );
}

export function SnapshotGuide() {
  return (
    <div className="hs-shot hs-shot--guide">
      <div className="hs-shot-bar">
        <strong>
          <PathIcon /> School guide
        </strong>
        <span>Year 7 path</span>
      </div>
      <ol className="hs-shot-steps hs-shot-steps--rich">
        <li className="is-done">
          <b>01</b>
          <div>
            <strong>Catchment</strong>
            <em>Priority bands on the map</em>
          </div>
        </li>
        <li className="is-on">
          <b>02</b>
          <div>
            <strong>How to apply</strong>
            <em>Register · CAF · evidence</em>
          </div>
        </li>
        <li>
          <b>03</b>
          <div>
            <strong>Exams</strong>
            <em>Papers · dates · shared tests</em>
          </div>
        </li>
        <li>
          <b>04</b>
          <div>
            <strong>Offer day</strong>
            <em>Place order · March</em>
          </div>
        </li>
      </ol>
      <p className="hs-shot-note">One calm path per school — written for parents.</p>
    </div>
  );
}

const SNAPSHOTS = {
  panel: SnapshotPanel,
  alloc: SnapshotAlloc,
  rank: SnapshotRank,
  compare: SnapshotCompare,
  oxbridge: SnapshotOxbridge,
  exams: SnapshotExams,
  deadlines: SnapshotDeadlines,
  guide: SnapshotGuide,
};

export default function DepthSnapshot({ kind }) {
  const Comp = SNAPSHOTS[kind] || SnapshotPanel;
  return <Comp />;
}
